import content from "#onboarding-content.gen.json" with { type: "json" };
import {
  ONBOARDING_SUMMARY_PLACEHOLDERS,
  type OnboardingContent,
  type OnboardingSummaryPlaceholder,
} from "#onboarding-content-types";

/**
 * The globe's pages, in order: the welcome, the questions, then the summary. Authored as
 * `@onboarding/intro/*.mdx`, built into `onboarding-content.gen.json` by `_build-onboarding`.
 */
export const ONBOARDING_INTRO_PAGES: OnboardingContent["intro"] = content.intro;

/** Each page's introduction in the sheet (`@onboarding/introductions/<page>/*.mdx`). */
export const ONBOARDING_INTRODUCTIONS: OnboardingContent["introductions"] = content.introductions;

/** The sheet's announcement of each unlocked destination (`@onboarding/announcements/*.mdx`). */
export const ONBOARDING_ANNOUNCEMENTS: OnboardingContent["announcements"] = content.announcements;

function isOnboardingSummaryPlaceholder(name: string): name is OnboardingSummaryPlaceholder {
  return (ONBOARDING_SUMMARY_PLACEHOLDERS as readonly string[]).includes(name);
}

/** The summary's `text` with its placeholders (`{characters}`, `{minutes}`) filled in. */
export function fillOnboardingSummaryPlaceholders(
  text: string,
  values: Readonly<Record<OnboardingSummaryPlaceholder, number>>,
): string {
  return text.replaceAll(/\{(?<name>[a-z]+)\}/gu, (placeholder, name: string) =>
    isOnboardingSummaryPlaceholder(name) ? String(values[name]) : placeholder,
  );
}
